module.exports = __webpack_public_path__ + "img/p2_preview_d1.d355b65c.png";